import React, { Component } from 'react';
import { basicDetailsSchema, employeeDetailsSchema, medicationDetailsSchema, estimateBreakupFormatSchema, addonSchema, 
    roomtypeSchema, includesSchema, excludesSchema } from '../../../schema/estimate-charges-corporate';
import Formcomponent from '../../../components/version2form_component';
import Tableantd from '../../../components/version2form_component/table/antd';
import { Modal, Spin, Button, Carousel, Icon } from 'antd';

const contentStyle = {
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
};

const $ = require('jquery');
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]
class Corporate_form extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            visible: false,
            'basicDetailsSchema': basicDetailsSchema['feilds'],
            'employeeDetailsSchema': employeeDetailsSchema['feilds'],
            'medicationDetailsSchema': medicationDetailsSchema['feilds'],
            'estimateBreakupFormatSchema': estimateBreakupFormatSchema['feilds'],
            'addonSchema': addonSchema['feilds'],
            roomtypeSchema: roomtypeSchema['feilds'],
            includesSchema: includesSchema['feilds'],
            excludesSchema: excludesSchema['feilds'],
            form_openn: 'corporate',
            addText: '',
            pre_link: '',
            modal1Visible: false, // includes
            modal2Visible: false, // Excludes
            modal3Visible: false, // Rooms
            img: false,
            img2: false,
            view_mode: false
        }
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.carousel = React.createRef();
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    }

    setModal1Visible(modal1Visible) {
        this.setState({ modal1Visible });
    }

    setModal2Visible(modal2Visible) {
        this.setState({ modal2Visible });
    }

    setModal3Visible(modal3Visible) {
        this.setState({ modal3Visible });
    }

    signModal(signModalVisible) {
        this.setState({ signModalVisible });
    }
    signsuccess() {
        this.signModal(false);
        this.setState({ img: true })
    }
    sign2Modal(signModal2Visible) {
        this.setState({ signModal2Visible });
    }
    sign2success() {
        this.sign2Modal(false);
        this.setState({ img2: true })
    }

    componentDidMount() {
        const { addonSchema, employeeDetailsSchema, medicationDetailsSchema, estimateBreakupFormatSchema } = this.state;
        let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);

        switch (slug) {
            case 'view-finanical-counselling':
                addonSchema.map((feild, key) => {
                    addonSchema[key]['disable'] = true;
                })
                employeeDetailsSchema.map((feild, key) => {
                    employeeDetailsSchema[key]['disable'] = true;
                })
                medicationDetailsSchema.map((feild, key) => {
                    medicationDetailsSchema[key]['disable'] = true;
                })
                estimateBreakupFormatSchema.map((feild, key) => {
                    estimateBreakupFormatSchema[key]['disable'] = true;
                })
                this.setState({ basicDetailsSchema: basicDetailsSchema, employeeDetailsSchema: employeeDetailsSchema,medicationDetailsSchema: medicationDetailsSchema, estimateBreakupFormatSchema: estimateBreakupFormatSchema, view_mode: true });
                break;
        }
    }

    componentWillUnmount() {
        this.setState({
            visible: false,
            formData: []
        });
    }
    
    cancel() {
        ;
        let { slug } = this.props.match.params;
        switch (slug) {
            case 'add-cash':
                this
                    .props
                    .history
                    .push('/settings/cash');
                break;
        }
    }


    validateModalFeilds(formFeilds) {
        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if ((feild['element'] === 'input' || feild['element'] === 'select2' || feild['element'] === 'Select2multiple' || feild['element'] === 'date')) {
                if (feild['name'] === 'role_id' && feild['value'] === 'RL_HjPW') {
                    role_id = true;
                } else {
                    role_id = false;
                }
                formFeilds[key]['errors'] = [];
                if (!feild.disable) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if (rule.test !== undefined && typeof rule.test === 'function' && !rule.test(feild['value'])) {
                                if (feild['name'] === 'counsellor_type') {
                                    formFeilds.map((feil, ke) => {
                                        if (feil['name'] === 'role_id' && feil['value'] === 'RL_HjPW' && feil['value'] !== null) {
                                            if (!(feild['value'] === '') || !(feild['value'] === null) || !(feild['value'] === undefined)) {
                                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                                errors.push(false);
                                            }
                                            else {
                                                console.log('no', feild['name'], feild['value'])
                                                formFeilds[key]['errors'] = [];
                                                errors.push(true);
                                            }
                                        }
                                    })
                                }
                                else {
                                    formFeilds[key]['errors'].push({ 'message': rule.message });
                                    errors.push(false);
                                }
                            }
                            else {
                                formFeilds[key]['errors'] = [];
                                errors.push(true);
                            }
                        })
                }
            }
        })

        this.setState((state) => ({ basicDetailsSchema: formFeilds }));
        return errors;
    }

    buttonClick(feilds, type) {
        console.clear();
        console.log('feilds', type, feilds);
    }

    buttonClick1(feilds, type) {
        console.clear();
        console.log('feilds', type);
    }

    buttonClick_cancel(){
        this.props.back()
    }

    buttonClick2(feilds, type) {
        console.clear();
        console.log('feilds', type, feilds);
        let ele_name = '';
        let ele_val = '';
        let ele_id = 0;
        let { medicationDetailsSchema, estimateBreakupFormatSchema, addonSchema } = this.state;

        let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);

        switch (slug) {
            case 'view-finanical-counselling':
                this.props.next()
                break;
                default:
        medicationDetailsSchema.map((feild, key) => {
            if (feild['name'] === type.type) {
                ele_name = feild['name'];
                ele_val = feild['value'];
                ele_id = feild['id'];
            }
        })
        if( ele_name === '' || ele_name === undefined || ele_name === null ){
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === type.type) {
                    ele_name = feild['name'];
                    ele_val = feild['value'];
                    ele_id = feild['id'];
                }
            })  
        }
        
        if (ele_name === 'care_management') {
            medicationDetailsSchema.map((feild, key) => {
                if (ele_val === 'Surgical') {
                    if (feild['name'] === 'estimate_type') {
                        medicationDetailsSchema[key]['visible'] = true;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'package_name') {
                        medicationDetailsSchema[key]['visible'] = true;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'date_of_surgery') {
                        medicationDetailsSchema[key]['visible'] = true;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'surgery_procedure_name') {
                        medicationDetailsSchema[key]['visible'] = true;
                        medicationDetailsSchema[key]['value'] = null;
                    }
        
                    addonSchema.map((feild, key) => {
                        if( feild['name'] == 'surgical_charges' ){
                            addonSchema[key]['visible'] = true;
                        }
                        if( feild['name'] == 'medical_charges' ){
                            addonSchema[key]['visible'] = false;
                        }
                    })
        
                    if( feild['id'] > ele_id){
                        medicationDetailsSchema[key]['value'] = null;
                    }
                }
                else {
                    if (feild['name'] === 'estimate_type') {
                        medicationDetailsSchema[key]['visible'] = false;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'package_name') {
                        medicationDetailsSchema[key]['visible'] = false;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'date_of_surgery') {
                        medicationDetailsSchema[key]['visible'] = false;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'surgery_procedure_name') {
                        medicationDetailsSchema[key]['visible'] = false;
                        medicationDetailsSchema[key]['value'] = null;
                    }
        
                    addonSchema.map((feild, key) => {
                        if( feild['name'] == 'surgical_charges' ){
                            addonSchema[key]['visible'] = false;
                        }
                        if( feild['name'] == 'medical_charges' ){
                            addonSchema[key]['visible'] = true;
                        }
                    })
        
                    if( feild['id'] > ele_id){
                        medicationDetailsSchema[key]['value'] = null;
                    }
                }
            })
            this.setState((state) => ({ 'medicationDetailsSchema': medicationDetailsSchema }));
        }
        
        if (ele_name === 'estimate_type') {
            medicationDetailsSchema.map((feild, key) => {
                if (ele_val === 'package') {
                    if (feild['name'] === 'package_name') {
                        medicationDetailsSchema[key]['visible'] = true;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'icu_stay') {
                        medicationDetailsSchema[key]['visible'] = false;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'room_stay') {
                        medicationDetailsSchema[key]['visible'] = false;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                }
                else{
                    if (feild['name'] === 'package_name') {
                        medicationDetailsSchema[key]['visible'] = false;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'icu_stay') {
                        medicationDetailsSchema[key]['visible'] = true;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'room_stay') {
                        medicationDetailsSchema[key]['visible'] = true;
                        medicationDetailsSchema[key]['value'] = null;
                    }
                }
            })
            this.setState((state) => ({ 'medicationDetailsSchema': medicationDetailsSchema }));
        }

        if (ele_name === 'icu_stay') {
            if (ele_val != '') {
                let total_stay = 0;
                medicationDetailsSchema.map((feild, key) => {
                    if (feild['name'] === 'room_stay') {
                        console.log(feild['value'])
                        if (feild['value'] != '' && feild['value'] != null && feild['value'] != NaN) {
                            total_stay = parseInt(ele_val) + parseInt(feild['value']);
                        }
                    }
                })
                addonSchema.map((feild,key) => {
                    if(feild['name'] === 'room_charges'){
                        addonSchema[key]['Specification']['table_body'].map((feild_1,key_1) => {
                            addonSchema[key]['Specification']['table_body'][key_1]['feilds'].map((feild_2,key_2) => {
                                if(addonSchema[key]['Specification']['table_body'][key_1]['feilds'][key_2]['name'] === 'icu_charges_qty'){
                                    console.log(addonSchema[key]['Specification']['table_body'][key_1]['feilds'][key_2])
                                    console.log('ele_val',ele_val)
                                    addonSchema[key]['Specification']['table_body'][key_1]['feilds'][key_2]['value'] = ele_val;
                                }
                            })
                        })
                    }
                })
                if( total_stay !='' && total_stay != NaN && total_stay != undefined && total_stay != null ){
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'length_of_stay') {
                            medicationDetailsSchema[key]['value'] = total_stay;
                        }
                    })
                }
                console.log('addonSchema',addonSchema)
                this.setState((state) => ({ 'medicationDetailsSchema': medicationDetailsSchema, 'addonSchema': addonSchema }));
            }
        }
        
        if (ele_name === 'room_stay') {
            if (ele_val != '') {
                let total_stay = 0;
                medicationDetailsSchema.map((feild, key) => {
                    if (feild['name'] === 'icu_stay') {
                        if (feild['value'] != '' && feild['value'] != null && feild['value'] != NaN) {
                            total_stay = parseInt(ele_val) + parseInt(feild['value']);
                        }
                    }
                })
                addonSchema.map((feild,key) => {
                    if(feild['name'] === 'room_charges'){
                        console.log(addonSchema[key]['Specification']['table_body'][0]['feilds'])
                        addonSchema[key]['Specification']['table_body'].map((feild_1,key_1) => {
                            addonSchema[key]['Specification']['table_body'][key_1]['feilds'].map((feild_2,key_2) => {
                                if(addonSchema[key]['Specification']['table_body'][key_1]['feilds'][key_2]['name'] === 'room_charges_qty'){
                                    addonSchema[key]['Specification']['table_body'][key_1]['feilds'][key_2]['value'] = ele_val;
                                }
                            })
                        })
                    }
                })
                if( total_stay !='' && total_stay != NaN && total_stay != undefined && total_stay != null ){
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'length_of_stay') {
                            medicationDetailsSchema[key]['value'] = total_stay;
                        }
                    })
                }
                this.setState((state) => ({ 'medicationDetailsSchema': medicationDetailsSchema }));
            }
        }
        
        if (ele_name === 'room_eligibility') {
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'room_upgrade') {
                    if (ele_val != '') {
                        estimateBreakupFormatSchema[key]['disable'] = false;
                    }
                    else {
                        estimateBreakupFormatSchema[key]['disable'] = true;
                    }
                }
            })
            this.setState((state) => ({ 'estimateBreakupFormatSchema': estimateBreakupFormatSchema }));
        }

        if (ele_name === 'room_upgrade') {
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'room_difference') {
                    if (ele_val != '') {
                        estimateBreakupFormatSchema[key]['disable'] = false;
                    }
                    else {
                        estimateBreakupFormatSchema[key]['disable'] = true;
                    }
                }
            })
            this.setState((state) => ({ 'estimateBreakupFormatSchema': estimateBreakupFormatSchema }));
        }
        break;
    }
    }

    addCash(feilds) {

    }

    feildChange1(ele) {
        console.clear();
        console.log(ele);
    }

    feildChange(ele) {
        let { medicationDetailsSchema, addonSchema } = this.state;

        let ele_name = ele['name'];
        let ele_val = ele['value'];
        let ele_id = ele['id'];
        // console.clear();
        console.log(ele)


        // this.setState((state) => ({ 'medicationDetailsSchema': medicationDetailsSchema }));

        if (ele['name'] === 'roomtypes') {
            let arr = [];
            let val = ele['value'];
            if (val == 'Single') {
                arr = ['https://www.kevinmd.com/blog/wp-content/uploads/shutterstock_48561808.jpg', 'https://aanchhospital.com/themes/images/PG5A1642.jpg', 'https://suneeldhand.com/wp-content/uploads/2014/02/Hospital-bed1-566x675.jpg', 'https://i.pinimg.com/originals/7b/04/86/7b0486ca7b6a0aca916bf5e05121be26.jpg', 'https://vizag.apollohospitals.com/wp-content/uploads/2016/05/Single-room.jpg']
            }
            if (val === 'Deluxe') {
                arr = ['https://medanta.org/wp-content/uploads/2017/04/SuDR1.jpg', 'https://www.jaslokhospital.net/Content/PhotoGallery/Suite-Deluxe.jpg']
            }
            if (val === 'Suite') {
                arr = ['https://5.imimg.com/data5/OD/QW/GLADMIN-9027984/treatment-executive-suite-room-500x500.png', 'https://cih.com.sg/wp-content/uploads/2018/02/4-1.jpg', 'https://meitra.com/wp-content/themes/meitra-hospital/images/Presidential-Suite.jpg']
            }
            if (val === 'General') {
                arr = ['https://3.imimg.com/data3/YT/HI/MY-9780834/1-500x500.jpg', 'https://yashodahospitalbijapur.in/wp-content/uploads/2018/07/general-ward.jpg', 'https://firstwesternhospital.healthcare/wp-content/uploads/2015/03/First-Western-Hospital-Koh-Phanagn-clinic-General-ward.jpg']
            }
            this.setState((state) => ({ 'rooms': arr }));
        }
    }

    next() {
        this.carousel.next();
    }
    previous() {
        this.carousel.prev();
    }

    render() {
        let { addonSchema, basicDetailsSchema, employeeDetailsSchema, medicationDetailsSchema, estimateBreakupFormatSchema, view_mode, img, img2 } = this.state;
        console.log('medicationDetailsSchema', medicationDetailsSchema)
        let { slug } = this.props.match.params;

        return (
            <div>
                <Spin spinning={this.state.loadding}>                   
                    <div className="card mx-5 mb-5 mt-2">
                        <div className="mx-4 mb-5 mt-4">
                            <Formcomponent className="row" {...this.props} {...this.state} feilds={employeeDetailsSchema} buttonClick={this.buttonClick2.bind(this)} />
                        </div>
                    </div>

                    <div className="card mx-5 mb-5 mt-2">
                        <div className="mx-4 mb-5 mt-4">
                            {/* <div className="row">
                                {medicationDetailsSchema.map((feild, key) => {
                                    if (feild.visible && feild.element === 'input') {
                                        return <Inputlayer {...this.props} {...this.state} feild_data={feild} key={key} inputChange={this.feildChange.bind(this)} />
                                    }
                                    if (feild.visible && feild.element === 'select') {
                                        return <Selectlayer {...this.props} {...this.state} key={key} feild_data={feild} inputChange={this.feildChange.bind(this)} />
                                    }
                                })}
                            </div> */}
                            <Formcomponent className="row" {...this.props} {...this.state} feilds={medicationDetailsSchema} buttonClick={this.buttonClick2.bind(this)} />
                        </div>
                    </div>

                    <div className="card pb-5 m-5">
                        <div className="financial-table table-responsive mt-5">
                            <h1 className="text-center text-capitalize text-heading mb-0">Estimation Breakdown Charges</h1>
                            {addonSchema.map((feild, key) => {
                                if (feild.visible) {
                                    return (<React.Fragment key={key}>
                                        <div className="d-inline-flex pl-5 w-100">
                                            <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                        </div>
                                        <div className="financial-table table-responsive">
                                            <Tableantd {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} />
                                        </div>
                                    </React.Fragment>)
                                }
                            })}
                            <div className="clearfix px-5">
                                <h1 className="float-left">Total</h1>
                                <h1 className="float-right">Rs. 0</h1>
                            </div>
                        </div>
                    </div>

                    <div className="card pb-5 m-5">
                        <div className="mx-4">
                            <Formcomponent className="row" {...this.props} {...this.state} feilds={estimateBreakupFormatSchema} buttonClick={this.buttonClick2.bind(this)} />
                        </div>
                        <div className="pt-5">
                             {/* Digital sign and submit*/}
                             <div className="d-flex justify-content-between mx-5 mb-5">
                                <div className="w-25">
                                    {img ?
                                        <React.Fragment>
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-50 h-50"></img>
                                        </React.Fragment>
                                        : null
                                    }
                                    <p>Patient/Attendant Name</p>
                                    <button className="btn btn-success text-capitalize" onClick={this.signModal.bind(this)}>Add Patient/Attendant Sign</button>
                                </div>
                                <div className="w-25 text-right">
                                    {img2 ?
                                        <React.Fragment>
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-50 h-50"></img>
                                        </React.Fragment>
                                        : null
                                    }
                                    <p>Counsellor Name</p>
                                    <button className="btn btn-success text-capitalize" onClick={this.sign2Modal.bind(this)}>Add Counsellor Sign</button>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-4">
                            <button className="btn btn-success btn-next text-capitalize" onClick={this.buttonClick_cancel.bind(this)}>Back</button>
                            { view_mode == false && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={this.buttonClick2.bind(this)}>Save</button>}
                            { view_mode && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={this.buttonClick2.bind(this)}>Next</button>}
                        </div>

                    </div>
                    {/* patient Sign */}
                    <Modal
                            title="Patient/Attendant  Signature"
                            centered
                            visible={this.state.signModalVisible}
                            onOk={() => this.signsuccess()}
                            onCancel={() => this.signModal(false)}
                            width={1000}
                            zIndex={1012}
                        >

                            <React.Fragment>
                                <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-100 h-100"></img>
                            </React.Fragment>
                        </Modal>

                        {/* fc Sign */}
                        <Modal
                            title="Counsellor Signature"
                            centered
                            visible={this.state.signModal2Visible}
                            onOk={() => this.sign2success()}
                            onCancel={() => this.sign2Modal(false)}
                            width={1000}
                            zIndex={1012}
                        >

                            <React.Fragment>
                                <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-100 h-100"></img>
                            </React.Fragment>
                        </Modal>
                </Spin>
            </div>
        )
    }
}
export default Corporate_form;